export default "__VITE_ASSET__6c3UC9CV__"